// extracted by mini-css-extract-plugin
export default {"Home":"style_Home__1gzZq","onSideClose":"style_onSideClose__uM6ub","minifySidebarContainer":"style_minifySidebarContainer__IPGq2","main":"style_main__CMD6k"};